import React, { useState } from "react";
import LoginForm from "../components/LoginForm";
import UserSignUpForm from "../components/UserSignUpForm";
import { ApiService } from "services/ApiService";
import { LoginRequest } from "models/LoginRequest";
import { useNavigate, useSearchParams } from "react-router-dom";
import { UserSignUp } from "models/UserSignUp";

const LoginPage: React.FC = () => {
    const [isNewUser, setIsNewUser] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState<string>('');
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const teamId = searchParams.get("teamId");
    const email = searchParams.get("email");
    const token = searchParams.get("token");

    const loginInternal = async (email: string, password: string) => {
        const loginRequest: LoginRequest = { email, password };
        const response = await ApiService.loginUser(loginRequest);
        if (!response.success) {
            console.log(response);
            alert("Please try again!");
            return;
        }

        if (teamId && email && token) {
            navigate(`/teams/${teamId}/teaminvites/accept?email=${encodeURIComponent(email)}&token=${encodeURIComponent(token)}`);
            return;
        }

        // Deterministic post-login routing handled by BootstrapRoute
        navigate('/bootstrap', { replace: true });
    };

    const handleLogin = async (email: string, password: string) => {
        setIsLoading(true);
        setLoadingMessage('Logging in...');
        try {
            await loginInternal(email, password);
        } catch (error) {
            console.error("Login error:", error);
            alert("Login failed. Please check your credentials.");
        } finally {
            setIsLoading(false);
            setLoadingMessage('');
        }
    };

    const handleSignUp = async (userData: UserSignUp) => {
        setIsLoading(true);
        setLoadingMessage('Signing up...');
        try {
            const signUpResponse = await ApiService.signUpUser(userData);
            if (!signUpResponse.success) {
                alert("Signup failed. Please try again!");
                return;
            }
            // Auto-login after successful signup
            setLoadingMessage('Logging in...');
            await loginInternal(userData.email, userData.passWord);
        } catch (error) {
            console.error("Signup error:", error);
            alert("Signup failed. Please check your information.");
        } finally {
            setIsLoading(false);
            setLoadingMessage('');
        }
    };

    return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
        {isLoading && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                <div className="bg-white w-full max-w-sm p-6 rounded-lg shadow-lg">
                    <div className="flex items-center gap-3">
                        <div className="h-5 w-5 rounded-full border-2 border-gray-300 border-t-gray-700 animate-spin" />
                        <p className="text-sm text-gray-800">{loadingMessage || 'Loading...'}</p>
                    </div>
                </div>
            </div>
        )}
        <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md flex flex-col items-center">
            {/* Top Switch */}
            <p className="mb-4 text-center w-full">
                {isNewUser ? "New User? " : "Already have an account? "}
                <span
                    onClick={() => setIsNewUser(!isNewUser)}
                    className="text-blue-500 hover:underline cursor-pointer"
                >
                    {isNewUser ? "Click here" : "Login Here"}
                </span>
            </p>
            {/* Form */}
            <div className="w-full">
                {isNewUser ? <LoginForm onSubmit={handleLogin} /> : <UserSignUpForm onSubmit={handleSignUp} />}
            </div>
            {/* Bottom Switch */}
            <p className="mt-4 text-center w-full">
                {isNewUser ? "New User? " : "Already have an account? "}
                <span
                    onClick={() => setIsNewUser(!isNewUser)}
                    className="text-blue-500 hover:underline cursor-pointer"
                >
                    {isNewUser ? "Click here" : "Login Here"}
                </span>
            </p>
        </div>
    </div>
);
};

export default LoginPage;